import appApi from "@/app/api";
import { TCloudAPIResponse } from "@/types/app";
import { CHECKOUT_SERVICE_BASE_URL } from "../constants.checkout";

const APIURL = `${CHECKOUT_SERVICE_BASE_URL}/addon/remove`;

export interface AddOnRemovePayload {
  product_id: string;
  final_quantity?: number; // optional field in case of removing the entire addon
}

interface AddOnRemoveOption {
  token: string;
  payload: AddOnRemovePayload;
}

type TResponse = TCloudAPIResponse<string>;

export async function handleAddOnRemove(
  option: AddOnRemoveOption,
): Promise<TResponse> {
  const headers = {
    Authorization: "Bearer " + option.token,
    "Content-Type": "application/json",
  };

  try {
    const response = await appApi.post(APIURL, option.payload, {
      headers,
    });

    return response.data as TResponse;
  } catch (error: any) {
    console.error("Error removing add-on:", error);
    throw error;
  }
}
